import { Spin } from 'antd';
import React, { lazy, Suspense, useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import Dashboard from './dashboard';
import Pages from './pages';
import Masters from './masters';
import Reports from './reports';
import MachineRawData from '../../container/machineRawData/MachineRawData';
import DiagnosticData from '../../container/DiagnosticData/DiagnosticData';
import withAdminLayout from '../../layout/withAdminLayout';
import ProcessedData from '../../container/processedData/ProcessedData';

const Monitor = lazy(() => import('../../container/monitor/Monitor'));
const Overview = lazy(() => import('../../container/monitor/overview'));
const Task = lazy(() => import('../../container/task/Index'));

const NotFound = lazy(() => import('../../container/pages/404'));

const Admin = React.memo(() => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return (
    <Suspense
      fallback={
        <div className="spin">
          <Spin />
        </div>
      }
    >
      <Routes>
        <Route index path="/*" element={<Dashboard />} />
        <Route path="pages/*" element={<Pages />} />
        <Route path="app/task/*" element={<Task />} />
        <Route path="raw-data/*" element={<MachineRawData />} />
        <Route path="processed-data/*" element={<ProcessedData />} />
        <Route path="diagnostic/*" element={<DiagnosticData />} />
        <Route path="masters/*" element={<Masters />} />

        <Route path="monitor/*" element={<Monitor />} />
        <Route path="monitor/view/:id/*" element={<Overview />} />
        <Route path="reports/*" element={<Reports />} />

        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
  );
});

export default withAdminLayout(Admin);
